import React, { Component, useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import history from '../../../route/history'
import { regisActions, alertActions } from '../../../store/actions'
import KTnetModal2 from '../../../module/ktnet/KTnetModal2'
import KTnetModalExport from '../../../module/ktnet/KTnetModalExport'
import KTnetModalImport from '../../../module/ktnet/KTnetModalImport'
import Input from '../../../module/input'
import moment from 'moment'
import Alert from '../../../module/alert/Alert'
import { valid } from '../../../hook/valid'

import ico_eye from '../../../assets/images/sub/eye_1.png'
import ico_eye_slash from '../../../assets/images/sub/eye_slash_1.png'


const CrtfctStep01 = (props) => {
  //console.log(JSON.parse(localStorage.getItem('user'))?.payload?.userSeCd)
  // 공인인증 툴킷open 여부
  console.log(props.crtfctInfos)
  const [isKTnetOpen, setIsKTnetOpen] = useState(false)

  const [isKTnetOpenExport, setIsKTnetOpenExport] = useState(false)

  const [isKTnetOpenImport, setIsKTnetOpenImport] = useState(false)

  const [pType, setPType] = useState('password')

  const [state, setState] = useState({
    isView: false,
    regNo1: '',
    regNo2: '',
    checkedRegNo: false, //주민번호 정상체크
    regNo: '',
    bizNo1: '',
    bizNo2: '',
    bizNo3: '',
    bizNo: '',
  })

  const [certChkInfo, setCertChkInfo] = useState({
    signCompleted: false,
    certChkYn: 'Y',
  })
  //사용자 가입용 데이터
  const [userInfo, setUserInfo] = useState({
    jtCrtfctId: '',
    jtCrtfctDn: '',
    bgngYmd: '',
    endYmd: '',
  })

  const handleChange = (e) => {
    const { value, name } = e.target // 우선 e.target 에서 name 과 value 를 추출
    setState({
      ...state, // 기존의 input 객체를 복사한 뒤
      [name]: value, // name 키를 가진 값을 value 로 설정
    })
  }
  /**
   * 인증서 툴킷 띄우기 전에 번호 확인
   * @param regNo1
   * @param regNo2
   * @returns
   */
  const toolkitCheckRegNo = (regNo1, regNo2) => {
    /*   setState({
        ...state,
        regNo: state.regNo1 + state.regNo2 
      }) */
    if (!regNo1) {
      return props.error({ message: '주민번호 앞자리를 입력해주세요.' })
    }
    if (!regNo2) {
      return props.error({ message: '주민번호 뒷자리를 입력해주세요.' })
    }

    let checkResult = valid.isValidJuminNo(regNo1, regNo2)
    if (!checkResult) {
      return props.error({ message: '정상적인 주민등록 번호가 아닙니다.' })
    }

    props.checkedRegNo(checkResult)
  }

  /**
   * 인증서 툴킷 띄우기 전에 번호 확인
   * @param bizNo1
   * @param bizNo2
   * @param bizNo3
   * @returns
   */
  const toolkitCheckBizNo = (bizNo1, bizNo2, bizNo3) => {
    /*   setState({
            ...state,
            regNo: state.regNo1 + state.regNo2 
          }) */
    if (!bizNo1) {
      return props.error({ message: '사업자번호 앞자리를 입력해주세요.' })
    }
    if (!bizNo2) {
      return props.error({ message: '사업자번호 중간자리를 입력해주세요.' })
    }
    if (!bizNo3) {
      return props.error({ message: '사업자번호 뒷자리를 입력해주세요.' })
    }
    var bizNoReg = bizNo1+bizNo2+bizNo3
    let checkResult = valid.checkbizNo(bizNoReg)
    //let checkResult = true
    if (!checkResult) {
      props.error({ message: '정상적인 사업자 번호가 아닙니다.\n 다시 한번 사업자 번호를 확인해주시기 바랍니다.' })
      // checkResult = true
    }

    props.checkedRegNo(checkResult)
  }
  const checkStepTrue = () => {
    localStorage.setItem('isSave', true)
  }

/*   const checkStepFalse = () => {
    props.confirm({
      title: '확인',
      message: '삭제하시겠습니까?',
      params: {
        type: 'confirm',
        callback: () => {
          localStorage.setItem('isSave', false)
        },
      },
    })
  } */
  useEffect(() => {
    props.checkCrtfctInfo({userId:JSON.parse(localStorage.getItem('user'))?.payload?.memberId})
  }, [])

  const checkStepFalse = () => {
    localStorage.setItem('isSave', false)
  }
  /**
   * 인증서 콜백
   * @param info
   */
  const crtfctInfo = (info) => {
    //console.log(localStorage.getItem('isSave'));
    let gbn
    if (JSON.parse(localStorage.getItem('user'))?.payload?.userSeCd === '01') {
      gbn = '1'
    } else {
      gbn = '2'
    }
    if (localStorage.getItem('isSave') === 'true') {
      props.onCrtfctfInfo(info, gbn)
      localStorage.removeItem('isSave')
    } else {
      props.delCrtfctfInfo(info, gbn)
      localStorage.removeItem('isSave')
    }
  }

  //tab
  let [step, setStep] = useState(1)

  const onSelected = (value) => {
    setStep(value)
  }

  return (
    <React.Fragment>
      <h3 className="h3-tit mt20">공동인증서 등록 안내{props.crtfctInfos?.data?.payload?.jtCrtfctDn ? ( <span style={{marginLeft: '10px', color: 'blue'}}>(등록완료)</span>) : (<span style={{marginLeft: '10px', color: 'red'}}>(미등록)</span>)}</h3>
      <div className="cert-gray-box">
        {JSON.parse(localStorage.getItem('user'))?.payload?.userSeCd === '01' && (
          <div className="cert-register">
            <span className="tit">주민등록번호</span>
            <input
              type="text"
              className="form-keyword"
              title={'주민등록번호'}
              id="regNo1"
              name="regNo1"
              maxLength="6"
              value={state.regNo1}
              autoComplete="no"
              onChange={(e) => handleChange(e)}
            />

            <span className="split">-</span>
            <input
              type={pType}
              className="form-keyword"
              title={'주민등록번호'}
              id="regNo2"
              name="regNo2"
              maxLength="7"
              autoComplete="new-password"
              value={state.regNo2}
              onChange={(e) => handleChange(e)}
            />
            <input type="hidden" className="form-keyword" id="gbn" name="gbn" value="1" />
            <img
                src= {pType === 'password' ? ico_eye : ico_eye_slash }
                alt=""
                className="pc-only"
                onClick={(e) => {
                  e.preventDefault()
                  setPType(pType === 'password' ? 'text' : 'password')
                }}
                style={{
                  position: 'relative',
                  height:'19px',
                  bottom: '-6px',
                  left: '2px',
                  maxWidth: '30px',
                }}
              />
              {props.crtfctInfos?.data?.payload?.jtCrtfctDn ? ( 
                <a
                  className="btn-secondary sm cursor"
                  onMouseDown={() => {
                    var result = toolkitCheckRegNo(state?.regNo1, state?.regNo2)
                    if (result?.type == 'ALERT_ERROR') return
                    props.confirm({
                      title: '확인',
                      message: '삭제하시겠습니까?',
                      params: {
                        type: 'confirm',
                        callback: () => {
                          checkStepFalse()
                          setIsKTnetOpen(true)
                        },
                      },
                    })
                  }}
                >
                  삭제
                </a>
              ) : (
                <a
                  className="btn-primary sm cursor"
                  onClick={() => {
                    var result = toolkitCheckRegNo(state?.regNo1, state?.regNo2)
                    if (result?.type == 'ALERT_ERROR') return
                    checkStepTrue()
                    setIsKTnetOpen(true)
                  }}
                >
                  등록
                </a>
              )}
          </div>
        )}
        {JSON.parse(localStorage.getItem('user'))?.payload?.userSeCd !== '01' && (
          <div className="cert-register">
            <span className="tit">사업자번호</span>
            {props.crtfctInfos?.data?.payload?.jtCrtfctDn ? ( 
              <input
                type="text"
                className="form-keyword"
                title={'사업자번호'}
                id="bizNo1"
                name="bizNo1"
                maxLength="3"
                readOnly
                value={(props.crtfctInfos.data.payload.groupRegistno).substr(0,3)}
                onChange={(e) => handleChange(e)}
              />
              ):(
              <input
                type="text"
                className="form-keyword"
                title={'사업자번호'}
                id="bizNo1"
                name="bizNo1"
                maxLength="3"
                value={state.bizNo1}
                onChange={(e) => handleChange(e)}
              />  
            )}
            <span className="split">-</span>
            {props.crtfctInfos?.data?.payload?.jtCrtfctDn ? ( 
              <input
                type="text"
                className="form-keyword"
                title={'사업자번호'}
                id="bizNo2"
                name="bizNo2"
                maxLength="2"
                readOnly
                value={(props.crtfctInfos.data.payload.groupRegistno).substr(3,2)}
                onChange={(e) => handleChange(e)}
              />
            ):(
              <input
                type="text"
                className="form-keyword"
                title={'사업자번호'}
                id="bizNo2"
                name="bizNo2"
                maxLength="2"
                value={state.bizNo2}
                onChange={(e) => handleChange(e)}
              />
            )}
            <span className="split">-</span>
            {props.crtfctInfos?.data?.payload?.jtCrtfctDn ? ( 
              <input
                type="text"
                className="form-keyword"
                title={'사업자번호'}
                id="bizNo3"
                name="bizNo3"
                maxLength="5"
                readOnly
                value={(props.crtfctInfos.data.payload.groupRegistno).substr(5)}
                onChange={(e) => handleChange(e)}
              />
            ):(
              <input
                type="text"
                className="form-keyword"
                title={'사업자번호'}
                id="bizNo3"
                name="bizNo3"
                maxLength="5"
                value={state.bizNo3}
                onChange={(e) => handleChange(e)}
              />
            )}
            <input type="hidden" className="form-keyword" id="gbn" name="gbn" value="2" />
            {props.crtfctInfos?.data?.payload?.jtCrtfctDn ? ( 
              <a
                className="btn-secondary sm cursor"
                onMouseDown={() => {
                  var result = toolkitCheckBizNo((props.crtfctInfos.data.payload.groupRegistno).substr(0,3), (props.crtfctInfos.data.payload.groupRegistno).substr(3,2), (props.crtfctInfos.data.payload.groupRegistno).substr(5))
                  if (result?.type == 'ALERT_ERROR') return
                  props.confirm({
                    title: '확인',
                    message: '삭제하시겠습니까?',
                    params: {
                      type: 'confirm',
                      callback: () => {
                        checkStepFalse()
                        setIsKTnetOpen(true)
                      },
                    },
                  })
                  console.log(props.confirm);
                }}
              >
                삭제
              </a>
            ) : (
              <a
                className="btn-primary sm cursor"
                onClick={() => {
                  var result = toolkitCheckBizNo(state?.bizNo1, state?.bizNo2, state?.bizNo3)
                  if (result?.type == 'ALERT_ERROR') return
                  checkStepTrue()
                  setIsKTnetOpen(true)
                }}
              >
                등록
              </a>
            )}
          </div>
        )}
        
      </div>
      {props.crtfctInfos?.data?.payload?.jtCrtfctDn ? (
        <ul className="h4-tit">
          <li>인증서 정보 :  {props.crtfctInfos.data.payload.jtCrtfctDn}</li>
          <li>인증서 유효기간 :   {moment(props.crtfctInfos.data.payload.endYmd).format('Y-MM-DD')}</li>
        </ul>
      ):(
        ''
      )}
      <ul className="ulist1 mt10">
        <li>인증서를 최초 1회 등록하시면 홈페이지 이용 시 편리하게 로그인할 수있습니다.</li>
        <li>인증서 갱신 및 재발급 시 인증서 재등록 후 이용이 가능합니다.</li>
        <li>은행인증서(무료) 또는 범용인증서(유료) 모두 이용 가능합니다.</li>
      </ul>
      <h3 className="h3-tit">공동인증서 등록 / 삭제 방법</h3>
      <div className="cert-box">
        <dl>
          <dt>간편 로그인 설정</dt>
          <dd>간편 로그인을 설정하시면, 연동된 계정으로 쉽고 빠른 로그인이 가능합니다.</dd>
        </dl>
      </div>
      <ol className="olist1 mt10">
        <li>
          <span>1</span>주민등록번호 입력 후 <strong>공동인증서 등록 또는 삭제</strong> 클릭
        </li>
        <li>
          <span>2</span>등록 또는 삭제할 공동인증서 선택 후 <strong>공동인증서 비밀번호</strong> 입력
        </li>
        <li>
          <span>3</span>인증서 삭제 완료
        </li>
      </ol>

      <KTnetModal2
        isKTnetOpen={isKTnetOpen}
        onChange={() => setIsKTnetOpen(false)}
        sendCrtfctInfo={crtfctInfo}
        error={props.error}
      />

      {/* <Alert /> */}
    </React.Fragment>
  )
}

const mapStateToProps = (state) => {
  return {
    checkedRegNo: state.regis.checkedRegNo,
    crtfctInfos : state.regis.crtfctInfos
  }
}

const actionCreators = {
  success: alertActions.success,
  error: alertActions.error,
  confirm: alertActions.confirm,
  checkedRegNo: regisActions.checkedRegNo,
  onCrtfctfInfo: regisActions.onCrtfctfInfo,
  delCrtfctfInfo: regisActions.delCrtfctfInfo,
  checkCrtfctInfo : regisActions.checkCrtfctInfo,
}

export default connect(mapStateToProps, actionCreators)(CrtfctStep01)
